<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">{{isCreate ? `Add ${page}` : `Edit ${page}`}}</h2>
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="#" @click="$router.go(-1)">Back</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{isCreate ? `Add ${page}`  : `Edit ${page}`}}</li>
        </ol>
      </div>
      <div class="d-flex">
      </div>
    </div>
    <div class="row row-sm justify-content-center">
      <div class="col-xl-7 col-lg-8 col-md-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Page</h6>
            </div>
            <div v-if="showVideo === true">
              <ValidationObserver ref="currencyAddForm" id="roomTypeAddForm" tag="form" class="d-flex flex-column" @submit.prevent="formSubmit()">
                <b-tabs content-class="mt-3">
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="users_id" class="form-label">User:</label>
                    <multiselect v-model="formData.user" :disabled="isEdit" placeholder="Select user" id="users_id" label="email" :class="classes"  :close-on-select="true" track-by="id" :options="users">
                      <template slot="singleLabel" slot-scope="props">
                        {{props.option.email}}
                      </template>
                      <template slot="option" slot-scope="props">
                        <span class="option__name">{{props.option.email}}</span>
                      </template>
                    </multiselect>
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="hotels_id" class="form-label">Hotel:</label>
                    <multiselect v-model="formData.hotel" :disabled="isEdit" placeholder="Select hotel" id="hotels_id" :custom-label="customLabel" :class="classes"  :close-on-select="true" track-by="id" :options="hotels">
                      <template slot="singleLabel" slot-scope="props">
                        {{props.option.title_l[$i18n.locale]}}
                      </template>
                      <template slot="option" slot-scope="props">
                        <span class="option__name">{{props.option.title_l[$i18n.locale]}}</span>
                      </template>
                    </multiselect>
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="status_id" class="form-label">Status:</label>
                    <select class="form-control" :class="checkValidation(classes)" name="" v-model="formData.status" id="status_id">
                      <option :value="key" v-for="(it, key) in statuses" :key="key">{{it}}</option>
                    </select>
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="provider_id" class="form-label">Provider:</label>
                    <select class="form-control" :disabled="isEdit" :class="checkValidation(classes)" name="" v-model="formData.provider" id="provider_id">
                      <option :value="key" v-for="(it, key) in providers" :key="key">{{it}}</option>
                    </select>
                  </ValidationProvider>
                  <button v-if="formData.provider !== 'db'" class="btn ripple btn-main-primary mt-2 mb-2" @click="openGlobalModal" type="button">Отправить запрос в GoGlobal</button>
<!--                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">-->
<!--                    <label for="extra_id" class="form-label">Extra:</label>-->
<!--                    <input type="text" class="form-control" :disabled="isEdit" :class="checkValidation(classes)" name="" v-model="formData.extra" id="extra_id">-->
<!--                  </ValidationProvider>-->
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="search_id" class="form-label">Search code:</label>
                    <input type="text" class="form-control" :disabled="isEdit" :class="checkValidation(classes)" name="" v-model="formData.search_code" id="search_id">
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="arrival_id" class="form-label">Arrival date:</label>
                    <input type="datetime-local" class="form-control" :disabled="isEdit" :class="checkValidation(classes)" name="" v-model="formData.arrival_date" id="arrival_id">
                  </ValidationProvider>
<!--                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">-->
<!--                    <label for="cancel_id" class="form-label">Cancel deadline:</label>-->
<!--                    <input type="datetime-local" class="form-control" :class="checkValidation(classes)" name="" v-model="formData.cancel_deadline" id="cancel_id">-->
<!--                  </ValidationProvider>-->
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="departure_id" class="form-label">Departure date:</label>
                    <input type="datetime-local" class="form-control" :disabled="isEdit" :class="checkValidation(classes)" name="" v-model="formData.departure_date" id="departure_id">
                  </ValidationProvider>
                </b-tabs>
                <button class="btn ripple btn-main-primary mt-2" :disabled="buttonDisable" :class="buttonDisable ? 'button-readonly' : ''">Submit</button>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal hide-footer hide-header ref="answerModal">
      <div class="main-mail-compose-box">
        <div class="main-mail-compose-header"><span>External</span>
          <nav class="nav">
            <div class="nav-link" @click="closeAnswerModal">
              <i class="fas fa-times"></i>
            </div>
          </nav>
        </div>
        <ValidationObserver ref="external" id="external" tag="div" class="main-mail-compose-body" >
          <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
            <label for="type_id" class="form-label">Types:</label>
            <select class="form-control" :class="checkValidation(classes)" name="type" v-model="externalData.type" id="type_id">
              <option :value="key" v-for="(it, key) in types" :key="key">{{it}}</option>
            </select>
          </ValidationProvider>
          <ValidationProvider v-if="externalData.type === 1" rules="required" tag="div" v-slot="{ classes }" class="form-group">
            <label for="credit_cards_id" class="form-label">Credit Cards:</label>
            <select class="form-control" :class="checkValidation(classes)" name="credit_card_id" v-model="externalData.credit_card_id" id="credit_cards_id">
              <option :value="it.id" v-for="(it, key) in creditCards" :key="key">{{it.title}}</option>
            </select>
          </ValidationProvider>
          <div class="form-group mg-b-0 d-flex justify-content-end">
            <button type="button" @click="saveExternal" class="btn ripple btn-primary">Send</button>
          </div>
        </ValidationObserver>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
const page = 'booking'
const url = 'booking'
export default {
  name: 'CityAdd',
  data () {
    return {
      page: page,
      url: url,
      showVideo: false,
      openModal: false,
      isEdit: false,
      buttonDisable: false,
      externalData: {},
      hotels: [],
      statuses: [],
      providers: [],
      users: [],
      types: [],
      creditCards: [],
      formData: {
      },
      isCreate: false,
      cookieId: ''
    }
  },
  computed: {
    ...mapState({
      languages: state => state.language.languages,
      itemData: state => state[page].itemData
    })
  },
  created () {
    this.cookieId = this.$route.params.id
    if (this.cookieId === 'add') {
      this.isEdit = false
      this.isCreate = true
      this.showVideo = true
    } else {
      this.isEdit = true
      this.getData({ id: this.cookieId }).then(res => {
        this.showVideo = true
        this.formData = this.itemData
      })
    }
    this.getCreateData().then((res) => {
      this.hotels = res.hotels
      this.providers = res.providers
      this.statuses = res.statuses
      this.users = res.users
    })
  },
  methods: {
    ...mapActions({
      create: page + '/create',
      update: page + '/update',
      getCreateData: page + '/getCreateData',
      getExternalCreateData: page + '/getExternalCreateData',
      saveExternalData: page + '/saveExternalData',
      getData: page + '/getData'
    }),
    saveExternal () {
      this.$refs.external.validate().then(success => {
        if (success) {
          if (this.itemData) {
            this.externalData.booking_id = this.itemData.id
          }
          this.saveExternalData(this.externalData).then(() => {
            this.$toasted.success(this.$t('messages.success.courseCreated')).goAway(1500)
            this.$refs.answerModal.hide()
          }).catch(err => {
            if (err.response.status === 422) {
              const data = err.response.data.errors
              const keys = Object.keys(data)
              const msg = data[keys[0]]
              this.$toasted.error(msg).goAway(1500)
            } else {
              this.$toasted.error(this.$t('messages.error.validationError')).goAway(1500)
            }
          })
        } else {
          this.$toasted.error(this.$t('messages.error.validationError')).goAway(1500)
        }
      })
    },
    closeAnswerModal () {
      this.$refs.answerModal.hide()
    },
    openGlobalModal () {
      this.$refs.answerModal.show()
      this.getExternalCreateData().then((res) => {
        this.creditCards = res.credit_cards
        this.types = res.types
      })
    },
    checkValidation (data) {
      return data
    },
    customLabel (data) {
      return `${data.title_l[this.$i18n.locale]}`
    },
    formSubmit () {
      this.$refs.currencyAddForm.validate().then(success => {
        if (success) {
          this.buttonDisable = true
          this.formData.hotel_id = this.formData.hotel.id
          this.formData.user_id = this.formData.user.id
          if (this.isCreate === true) {
            this.create(this.formData).then(() => {
              this.$toasted.success(this.$t('messages.success.courseCreated')).goAway(1500)
              this.$router.push('/' + this.url)
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data.errors
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.message).goAway(1500)
                }
              }
            }).finally(() => {
              this.buttonDisable = false
            })
          } else {
            this.update({ data: this.formData, id: this.$route.params.id }).then(res => {
              this.$toasted.success(this.$t('messages.success.courseUpdated')).goAway(1500)
              this.$router.push('/' + this.url)
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data.errors
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.message).goAway(1500)
                }
              }
            }).finally(() => {
              this.buttonDisable = false
            })
          }
        } else {
          this.$toasted.error(this.$t('messages.error.validationError')).goAway(1500)
        }
      })
    }
  }
}
</script>
